import { JSX } from "react";
import { ProductDownloadEntry } from "../../../../utils/productDetail/buildProductDownloadEntries";
import { PRODUCT_SPEC_COLUMN_COUNT } from "../../../../utils/productDetail/productSpecificationsConstants";
import { ProductDetailColumnGrid } from "../shared/ProductDetailColumnGrid";
import { ProductDownloadEntryItem } from "./ProductDownloadEntryItem";

interface Props {
    entries: ProductDownloadEntry[];
}

export const ProductDownloadsGrid = ({ entries }: Props): JSX.Element => {
    const items = entries.map((entry) => (
        <ProductDownloadEntryItem key={entry.key} entry={entry} />
    ));

    return (
        <ProductDetailColumnGrid
            items={items}
            columnCount={PRODUCT_SPEC_COLUMN_COUNT}
        />
    );
};
